import { forwardRef, type InputHTMLAttributes } from "react";
import { PasswordField as ArcPasswordField } from "../components/arc/password-field/password-field";
import styles from "./password-field.module.css";

export interface PasswordFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  /** Helper copy under the field. */
  description?: string;
  /** Replaces the helper copy in the danger colour, marks the field invalid and is announced. */
  error?: string;
}

/**
 * Arc's password field with an error state, like Arc's Input has. Arc styles `aria-invalid`
 * (a danger border) but has no error row, and its files are vendored, so the error takes the
 * helper row's place here.
 */
export const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(function PasswordField(
  { description, error, ...props },
  ref,
) {
  return (
    <div className={styles.wrap} data-invalid={error ? "" : undefined}>
      <ArcPasswordField
        {...props}
        ref={ref}
        description={error ?? description}
        aria-invalid={error ? true : props["aria-invalid"]}
      />
      {error ? (
        <span role="alert" className={styles.announce}>
          {error}
        </span>
      ) : null}
    </div>
  );
});
